export const getBaseUrl = (): string => {
  let baseUrl = process.env.PUBLIC_URL;

  if (baseUrl.endsWith("/")) {
    baseUrl = baseUrl.substring(0, baseUrl.length - 2);
  }
  return baseUrl;
};

export default (path: string) => {
  let baseUrl = getBaseUrl();

  if (path.toLowerCase().startsWith(baseUrl.toLowerCase())) {
    return path;
  }
  return baseUrl + path;
};

export function stripRelativePath(uri: string): string {
  if (uri.toLowerCase().startsWith(getBaseUrl().toLowerCase())) {
    return uri.substr(getBaseUrl().length);
  }
  return uri;
}
